import React, { useCallback, useEffect, useState } from "react";
import Dashboard from "components/Template/Dashboard";
import { listEntity } from "services/entity";
import NoData from "components/NoData";
import Loading from "components/Loading";
import ModalStatus from "./ModalStatus";
import TableEntity from "./TableEntity";
import RowSearch from "./RowSearch";
import toastMessage from "helpers/handleToastMessage";
import { ToastContainer } from "react-toastify";

type Props = {};

const EntityIndex: React.FC<Props> = (): JSX.Element => {
  const [dataList, setDataList] = useState<any>([]);
  const [show, setShow] = useState<boolean>(false);
  const [enabled, setEnabled] = useState<any>(null);
  const [changeStatus, setChangeStatus] = useState("");
  const [loading, setLoading] = useState<boolean>(false);
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("asc");

  const list = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await listEntity(search);
      setDataList(data);
    } catch (error: any) {
      toastMessage({
        message: "Error, Something went wrong.",
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  }, [search]);

  useEffect(() => {
    list();
  }, [list]);

  return (
    <Dashboard
      title={"Entity Management"}
      breadcrumb={[]}
      info={dataList.length}
      subInfo={"Entities / Lawyers"}
      children={
        <>
          <Loading loading={loading} />
          <ToastContainer />
          <RowSearch search={search} setSearch={setSearch} />
          {dataList.length > 0 ? (
            <>
              <ModalStatus
                show={show}
                setShow={setShow}
                setLoading={setLoading}
                enabled={enabled}
                setEnabled={setEnabled}
                changeStatus={changeStatus}
                setChangeStatus={setChangeStatus}
                reloadList={list}
              />
              <TableEntity
                dataList={dataList}
                setDataList={setDataList}
                status={status}
                setStatus={setStatus}
                setShow={setShow}
                setEnabled={setEnabled}
                setChangeStatus={setChangeStatus}
              />
            </>
          ) : (
            <NoData />
          )}
        </>
      }
    />
  );
};

export default EntityIndex;
